import { isCompact, isExpanded, isMedium, User } from '../../../types';
import { Column, DisplayLarge, DisplaySmall, HeadlineLarge, HeadlineSmall } from '../../../styles';
import { Banner, GreetingIcon } from './styles';
import { useTranslations } from 'next-intl';
import { useBreakpoint } from '../../../hooks';

type Props = Pick<User, 'firstname' | 'lastname'>;

export const DashboardScreenGreetingSection = ({ firstname, lastname }: Props) => {
    const t = useTranslations('dashboard');
    const breakpoint = useBreakpoint();
    const expanded = isExpanded(breakpoint);
    const medium = isMedium(breakpoint);
    const compact = isCompact(breakpoint);
    const greeting = t('title', { name: `${firstname} ${lastname}` });

    const renderGreeting = () => {
        if (expanded) return <DisplayLarge color={'white'}>{greeting}</DisplayLarge>;
        else if (medium) return <DisplaySmall color={'white'}>{greeting}</DisplaySmall>;
        else if (compact) return <HeadlineLarge color={'white'}>{greeting}</HeadlineLarge>;
    };

    return (
        <Banner pt={5} pb={4} px={3} gap={2} stretch={!expanded}>
            <Column gap={1}>
                {renderGreeting()}
                <HeadlineSmall color={'white'}>{t('greeting')}</HeadlineSmall>
            </Column>
            <GreetingIcon isCompact={compact} />
        </Banner>
    );
};
